import { useCallback } from 'react';

export const useGetStationUniversalLink = () => {
  const getStationUniversalLink = useCallback((stationCode: string) => {
    const base64UrlParams = window.btoa(JSON.stringify({
      screen: "stationDetails",
      stationID: stationCode
    }));
  
    return `${window.location.origin}/mobile?params=${base64UrlParams}`;
  }, []);

  return getStationUniversalLink;
};
